import service from "@/store/services/divisiones-service";

const state = {
  list: {},
  division: {},
  meta: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, division) => {
    state.division = division;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
};

const actions = {
  list({ commit, dispatch }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params).then((role) => {
      commit("SET_RESOURCE", role);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params).then((division) => {
      commit("SET_RESOURCE", division);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params).then((division) => {
      commit("SET_RESOURCE", division);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.pagination.total,
  division: (state) => state.division,
  dropdown: (state) => {
    return state.list.map((division) => ({
      id: division.id,
      nombre: division.nombre,
    }));
  },
};

const divisiones = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default divisiones;
